import { home } from 'ionicons/icons'

export const peopleOptions = (language: 'fi' | 'en') => {
	const henkilo = language === 'fi' ? 'henkilö' : 'person'
	const henkiloa = language === 'fi' ? 'henkilöä' : 'persons'
	const yli = language === 'fi' ? 'Yli 6 henkilöä' : 'Over 6 persons'

	return [
		{
			text: `1 ${henkilo}`,
			value: 1,
		},
		{
			text: `2 ${henkiloa}`,
			value: 2,
		},
		{
			text: `3 ${henkiloa}`,
			value: 3,
		},
		{
			text: `4 ${henkiloa}`,
			value: 4,
		},
		{
			text: `5 ${henkiloa}`,
			value: 5,
		},
		{
			text: `6 ${henkiloa}`,
			value: 6,
		},
		{
			text: yli,
			value: 99,
		},
	]
}

export const heatingOptions = (language: 'fi' | 'en') => {
	return [
		{
			icon: home,
			label: language === 'fi' ? 'Suora sähkölämmitys' : 'Direct electric heating',
			value: 'electric',
		},
		{
			icon: home,
			label: language === 'fi' ? 'Ajastettu sähkölämmitys' : 'Optimised electric heating',
			value: 'timedElectric',
		},
		{
			icon: home,
			label: language === 'fi' ? 'Kaukolämpö' : 'District heating',
			value: 'district',
		},
		{
			icon: home,
			label: language === 'fi' ? 'Maalämpö' : 'Geothermal heating',
			value: 'geothermal',
		},
		{
			icon: home,
			label: language === 'fi' ? 'Öljylämmitys' : 'Oil heating',
			value: 'oil',
		},
		{
			icon: home,
			label: language === 'fi' ? 'Puulämmitys' : 'Wood heating',
			value: 'wood',
		},
		{
			icon: home,
			label: language === 'fi' ? 'Vesi-ilmalämpöpumppu' : 'Water-air heat pump',
			value: 'airWaterHeatPump',
		},
	]
}

export const secondaryHeatingOptions = (language: 'fi' | 'en') => {
	return [
		{
			label: language === 'fi' ? 'Ilmalämpöpumppu' : 'Air-source heat pump',
			value: 'heatPump',
		},
		{
			label: language === 'fi' ? 'Erillinen lattialämmitys' : 'Separate floor heating system',
			value: 'underfloorHeating',
		},
		{
			label: language === 'fi' ? 'Takka' : 'Fireplace',
			value: 'fireplace',
		},
	]
}
export const consumptionElementOptions = (language: 'fi' | 'en') => {
	return [
		{
			label: language === 'fi' ? 'Lämminvesivaraaja' : 'Hot water heater',
			type: 'waterHeater',
			name: 'Lämminvesivaraaja',
		},
		{
			label: language === 'fi' ? 'Sähköauton lataus' : 'Electric car charger',
			type: 'electricCar',
			name: 'Sähköauto',
		},
		{
			label: language === 'fi' ? 'Poreallas' : 'Hot tub',
			type: 'jacuzzi',
			name: 'Poreallas',
		},
		{
			label: language === 'fi' ? 'Sähkösauna' : 'Electric sauna',
			type: 'sauna',
			name: 'Sauna',
		},
	]
}
